import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const unsplash = defineConnector({
  identifier: "unsplash",
  name: "Unsplash",
  tagLine: "Freely usable stock photography",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.unsplash\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessKey,
        scheme: "Client-ID",
      },
    ]),
  steps: [
    {
      title: "Register an application",
      items: [
        {
          kind: "markdown",
          content:
            "Create an application at [Unsplash developers](https://unsplash.com/oauth/applications), then copy its **Access Key**.",
        },
      ],
    },
    {
      title: "Copy and paste the access key into the field below",
      items: [
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.unsplash.com/photos?per_page=1",
  },
});
